import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { Button } from "@omni/ui/components/Button/button.component";
import { KeyFeatures } from "@omni/ui/components/Product/Feature/KeyFeatures/keyFeatures";
import { cn } from "@omni/utils/styles";

import { scrollToElementById } from "@/utils/scroll";

export const KeyFeaturesComponent = () => {
    const { t } = useGranite();

    const title = t("productDetail.title.keyFeatures");

    const handleOnShowMoreClick = () => {
        scrollToElementById("specs");
    };

    return (
        <>
            {title && <p className={cn("h5")}>{title}</p>}
            <KeyFeatures.Features className={cn("tw:list-none tw:p-0")}>
                <KeyFeatures.Feature
                    className={cn(
                        "tw:border-t tw:border-t-solid tw:border-t-grey-light tw:flex tw:justify-between tw:py-3 tw:last:border-b tw:last:border-b-solid tw:last:border-b-grey-light"
                    )}
                >
                    <KeyFeatures.Feature.Name />
                    <KeyFeatures.Feature.Value />
                </KeyFeatures.Feature>
            </KeyFeatures.Features>
            <Button
                color={"link"}
                className={cn("tw:hidden tw:lg:inline-block tw:p-0")}
                onClick={handleOnShowMoreClick}
            >
                {t("productDetail.link.showMoreFeatures")}
                <i className={cn("las la-angle-right la-lg")}></i>
            </Button>
        </>
    );
};
